<!-- The progressbar that is shown above questions -->
<template>
    <div progressbar aria-live="assertive">
        <div data-bar>
            <span
                data-value-label
                :style="{ 
                    width: `${progressPercentage}%`
                }"
            >
                <span data-only-screenreader>{{this.$store.getters.textResource(`rs_progress`)}}</span>
                <p data-progress-percentage v-if="layout.ProgressBar.ShowProgressTopPublicName === 'WithPercentage'">{{ progressPercentage }}%</p>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: `progress-bar`,
    computed: {
        state: function () {
            return this.$store.state;
        },
        progressPercentage: function () {
            let page = this.state.page;
            if (page === undefined) return 0;

            let progress = parseInt(page.progress);

            if (progress < 0) return 0;
            else if (progress > 100 || isNaN(progress)) return 100;
            return progress;
        },
        layout: function () {
            return this.state.layout;
        },
    },
};
</script>

<style scoped>
[progressbar] {
    position: relative;
    height: 101px;
    width: 100%;
    margin-block-end: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    max-width: 1000px;
    justify-self: center;
}

[progressbar] [data-bar] {
    background: var(--progressbar-color-25);
    border-radius: 50px;
    height: 24px;
    width: 100%;
    display: block;
    position: relative;
}

[progressbar] [data-value-label] {
    background: var(--progressbar-color);
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 10px;
    text-align: center;
    transition: 0.5s ease-out;
    min-width: 80px;
    font-family: var(--page-font-family-public-name);
    color: var(--progresspercentage-color);
    min-height: 24px;
}

[progressbar] [data-value-label] p {
    margin: 0;
    top: -20px;
    right: 0;
    position: absolute;
    color: var(--progresspercentage-color);
    font-size: 16px;
    font-weight: 600;
}
</style>